var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6094 40.0279C54.6233 55.8284 37.7724 64.5952 21.972 59.6091C6.17147 54.623 -2.59532 37.7721 2.39079 21.9716C7.3769 6.17113 24.2278 -2.59565 40.0283 2.39046C55.8287 7.37657 64.5955 24.2274 59.6094 40.0279Z",
    fill: "url(#paint0_linear_652_34555)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_652_34555",
    x1: 7.00102,
    y1: 0.60376,
    x2: 60.3172,
    y2: 34.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#F4F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E7EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLoad);
export default __webpack_public_path__ + "static/media/ButtonLoad.bdc998243134312001b077eb74ac6f63.svg";
export { ForwardRef as ReactComponent };